/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FlexLayout from '../../../components/common/FlexLayout';
import IconButton from '../../../components/common/IconButton';
import ActionPanel from '../../../components/Controller/ActionPanel';
import PopupOverlay from '../../../components/common/PopupOverlay';
import { alertWrapper } from '../../../utils/alertWrapper';

const TypeSelector = ({
  selectedCategory,
  setSelectedCategory,
  variantData,
  isDataReady,
  setIsDataReady,
  setIsLoading,
  selectedVariant,
  openAlertDialog,
  isConfigSaved,
  getAccessoryVariantData
}) => {
  const [shouldOpen, setShouldOpen] = useState(true);
  const [activeHelmetType, setActiveHelmetType] = useState(-1);
  const [isAlertConfirmed, setIsAlertConfirmed] = useState(true);

  const onVariantChange = (i, option) => {
    setIsLoading(true);
    setActiveHelmetType(i);
    getAccessoryVariantData(option.variantId);
    setTimeout(() => {
      setShouldOpen(false);
      setSelectedCategory('baseColor');
    }, 400);
  };

  const onVariantChangeCancel = () => {
    setIsLoading(true);
    setShouldOpen(false);
    setSelectedCategory('baseColor');
    if (!isDataReady) {
      setTimeout(() => {
        setIsDataReady(true);
      }, 10);
    }
  };

  useEffect(() => {
    if (selectedCategory === 'helmetType') {
      setShouldOpen(true);
      setIsDataReady(false);
    } else if (isDataReady) {
      setShouldOpen(false);
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (selectedVariant) setShouldOpen(false);
  }, [selectedVariant]);

  return (
    <PopupOverlay isOpen={shouldOpen}>
      <div className="type-selector_box">
        <ActionPanel
          label="Select Your Helmet Type"
          isCloseButtonHidden={!window.ScapicSDK || isAlertConfirmed}
          onCloseButtonClick={onVariantChangeCancel}
        >
          <FlexLayout flexDirection="row" justifyContent="space-evenly">
            {variantData.map((option, i) => (
              <div key={i} className="type-selector_option">
                <IconButton
                  backgroundColor={activeHelmetType === i ? '#000' : '#fff'}
                  iconColor={activeHelmetType === i ? '#fff' : '#000'}
                  label={option.name}
                  icon={option.thumbnail}
                  onClick={() => {
                    alertWrapper(
                      {
                        isOpen:
                          selectedVariant !== '' &&
                          !isConfigSaved &&
                          !isAlertConfirmed,
                        title: 'Customization Not Saved',
                        message:
                          'Changing Variant without saving will result in lose of customization. Click on Save on Topbar or continue anyway without saving',
                        agreeButtonText: 'Continue Anyway',
                        disagreeButtonText: 'Cancel',
                        onAgree: () => {
                          onVariantChange(i, option);
                          setIsAlertConfirmed(false);
                        },
                        onDisagree: onVariantChangeCancel
                      },
                      openAlertDialog,
                      selectedVariant !== '' && !isConfigSaved
                    );
                    if (isAlertConfirmed) {
                      onVariantChange(i, option);
                      setIsAlertConfirmed(false);
                    }
                  }}
                />
              </div>
            ))}
          </FlexLayout>
        </ActionPanel>
      </div>
    </PopupOverlay>
  );
};

TypeSelector.propTypes = {
  setSelectedCategory: PropTypes.func,
  selectedCategory: PropTypes.string,
  variantData: PropTypes.array,
  getAccessoryVariantData: PropTypes.func,
  isDataReady: PropTypes.bool,
  setIsDataReady: PropTypes.func,
  setIsLoading: PropTypes.func,
  selectedVariant: PropTypes.string,
  openAlertDialog: PropTypes.func,
  isConfigSaved: PropTypes.bool
};

export default TypeSelector;
